import type { ApplicationRegistryItem } from "@aviv-unified-frontend/registry";

import { registry } from "../../../configs/registry";
import {
  ALLOW_RUNTIME_FEDERATION_VERSION_OVERLOADING,
  IS_RUNTIME_FEDERATION,
} from "../../constants/environment";

import { updateUrlVersion } from "./updateUrlVersion";

type GetApplicationScriptUrl = {
  id?: ApplicationRegistryItem["id"] | undefined;
  version?: string | undefined;
};

export const getApplicationScriptUrl = ({
  id,
  version,
}: GetApplicationScriptUrl) => {
  const baseUrl = id && registry.getApplicationFromId(id)?.urls.client;

  if (!baseUrl) return null;

  const runtimeVersion = ALLOW_RUNTIME_FEDERATION_VERSION_OVERLOADING
    ? version
    : undefined;

  return IS_RUNTIME_FEDERATION && runtimeVersion
    ? updateUrlVersion(baseUrl, runtimeVersion)
    : baseUrl;
};
